/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.academy.catalog.rpc.v1.CatalogResourceChirpFrontendService
 */
import { createRpcClientV2 } from 'rpc-client-utils';
import { registerQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
import * as References from './CatalogResourceChirpFrontendService';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.academy.catalog.rpc.v1.CatalogResourceChirpFrontendService#getCatalogResources
 */
export const GET_CATALOG_RESOURCES_QUERY = /* #__PURE__ */registerQuery({
  fieldName: 'getCatalogResources',
  args: ['requestedResources'],
  fetcher(request) {
    return chirpClient.call(References.getCatalogResourcesRpc, {
      request
    });
  }
});